var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-block"},[_c('svg-icon',{attrs:{"iconClass":_vm.iconClass,"size":'16px',"className":"message-icon"}}),_vm._t("message")],2)}
var staticRenderFns = []

export { render, staticRenderFns }